export default "__VITE_ASSET__3536573e__"